import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import css from './index.module.css';
import { useParams } from 'react-router';
import Table from '../../../../components/common/table/table';
import { useService } from '../../../../services/services';
import VaadLizReportsHistory from '../../../../interfaces/vaadLizReportsHistory';

export default function ReportsHistoryIndex() {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const { vaadLizReportService } = useService();

  const transKeyPrefix = 'pages.crop.vaad_liz_reports.';
  const tp = useCallback(
    (key: string, params?: any) => t(transKeyPrefix.concat(key), params),
    [t]
  );

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      vaadLizReportService.index(farmId, { page, sort, desc, ...filter }),
    [vaadLizReportService, farmId]
  );

  const contentStrings = (row: VaadLizReportsHistory) => {
    const contentArray = row.content.split(',');
    return (
      <table className={css['warehouses']}>
        <tbody>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>
              {contentArray.map((content, index) => (
                <li key={index}>{content.trim()}</li>
              ))}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <div className={css['index']}>
      <div className={css['body']}>
        <Table<VaadLizReportsHistory>
          request={request}
          keyAccessor="id"
          rowExpander={contentStrings}
          columns={[
            {
              accessor: 'date',
              header: tp('created'),
              sortable: true,
              className: css['strong'],
            },
            {
              accessor: 'name',
              header: tp('file_name'),
              sortable: true,
              className: css['strong'],
              onRowClick: (item: any) =>
                vaadLizReportService
                  .downloadHistoryReportsZip(farmId, item.file_id)
                  .subscribe((data) => {}),
            },
            {
              accessor: 'status',
              header: tp('status'),
              sortable: true,
              className: css['strong'],
            },
          ]}
        />
      </div>
    </div>
  );
}
